import { createReference } from "../lib/firebase";
import { FirebaseStore } from "../lib/FirebaseStore";
import type { VoteOption } from "./VoterStore";

const FIREBASE_KEY = "session";

// TYPES
// -----

export const VotingState = {
  WAITING: "waiting",
  VOTING: "voting",
  RESULTS: "results",
  ENDED: "ended",
} as const;

export const votingStates = Object.values(VotingState);

export type VotingState = (typeof VotingState)[keyof typeof VotingState];

export interface VotingSessionData {
  state: VotingState;
  winnerOverride?: VoteOption | null;
  winner?: "green" | "pink" | null;
}

// VOTING STATE
// ------------

interface VotingSessionOptions {
  eventPrefix: string;
}

export class VotingSessionStore extends FirebaseStore<VotingSessionData> {
  constructor({ eventPrefix }: VotingSessionOptions) {
    super(createReference(eventPrefix, FIREBASE_KEY));
  }
}
